// @flow
import * as React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { NavLink } from 'react-router-dom';
import Bell from '../Icons/Bell';
import { below } from '../../assets/css/media';
import colors from '../../assets/css/colors';
import type { TRootStore } from '../../modules/types/store';
import * as selectors from '../../modules/selectors';
import * as actions from '../../modules/actions';

const Alerts = styled(NavLink)`
	display: flex;
	justify-content: center;
	align-items: center;
	color: ${colors.title};
	margin-right: 5em;
	text-decoration: none;

	.count-alerts {
		display: inline-flex;
		justify-content: center;
		align-items: center;
		width: 20px;
		height: 20px;
		background: ${colors.nrlGreen};
		font-weight: bold;
		border-radius: 50%;
		margin: 0 .3em;
	}

	svg {
		color: ${colors.nrlGreen};
		margin-right: .3em;
	}
`;

const AlertSpan = styled.span`
	${below.desktop`
		display: none;
	`}
`;

const ShowMobileSpan = styled.span`
	${below.desktop`
		margin-right: -30px;
	`}
`;

const AlertBell = styled(Bell)`
	${below.desktop`
		display: none;
	`}
`;

type Props = {
	// fetchNotificationsDraft: Function,
	fetchTrades: typeof actions.teamsDraft.fetchTrades,
	fetchWaiverRequests: typeof actions.leagueDraft.fetchWaiverRequests,
	counter: number,
	team_id: number,
	id: number,
	trades: Object,
	match: Object,
	waiver_requests: Array<number>
};

export class DraftNotificationsContainer extends React.Component<Props> {

	componentDidMount() {
		const {
			// fetchNotificationsDraft,
			fetchTrades,
			fetchWaiverRequests,
			// team_id,
			match: { params: { league_id } },
		} = this.props;
		// fetchNotificationsDraft({ team_id });
		fetchTrades({ league_id });
		fetchWaiverRequests({ league_id });

	}

	render() {
		const { id, trades, waiver_requests } = this.props;
		const alert_count = _.size(trades.my) + _.size(trades.proposed) + _.size(waiver_requests);
		if (!alert_count) {
			return null;
		}
		return (
			<Alerts to={`/league/${id}/transactions`}>
				<AlertBell size="1.6" />
				<AlertSpan>You have</AlertSpan>
				<ShowMobileSpan>
					<span className='count-alerts'>{alert_count}</span>
					alert{alert_count === 1 ? '' : 's'}
				</ShowMobileSpan>
			</Alerts>
		);
	}
}
const mapStateToProps = (state: TRootStore, props) => ({
	counter: state.notifications.counter,
	league: selectors.leagueDraft.getLeague(state, props),
	trades: state.teamsDraft.trades,
	waiver_requests: state.leagues.waiver_requests.ordered_ids,
});

const mapDispatchToProps = {
	// fetchNotificationsDraft: actions.fetchNotificationsDraft,
	fetchTrades: actions.teamsDraft.fetchTrades,
	fetchWaiverRequests: actions.leagueDraft.fetchWaiverRequests,
};

export const DraftNotifications = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(DraftNotificationsContainer)
);

export default DraftNotifications;


// WEBPACK FOOTER //
// ./src/components/DraftNotifications/index.js